import { Injectable, OnDestroy } from '@angular/core';
import { HttpInterceptor } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService implements OnDestroy {
  private destroying = new Subject();
  private isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public set isLoading(isLoading: boolean) {
    this.isLoading$.next(isLoading);
  }

  public get loadingState(): Observable<boolean> {
    return this.isLoading$.asObservable();
  }
  ngOnDestroy() {
    this.destroying.next();
  }
}
